import React from 'react';
import { Box, CircularProgress, Dialog, DialogContent, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { EditRosterTemplateForm } from './EditRosterTemplateScreen';
import { RosterTemplateFormValues } from './RosterTemplateForm';

interface EditRosterTemplateDialogProps {
  rosterTemplateId: string;
  onClose: () => void;
  onSaved: (values?: RosterTemplateFormValues) => void;
  onDeleted: () => void;
}

export const EditRosterTemplateDialog = ({
  rosterTemplateId,
  onClose,
  onSaved,
  onDeleted,
}: EditRosterTemplateDialogProps) => {
  const { isMobile } = useCampfireTheme();

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth='xl'
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        style: {
          height: isMobile ? '100vh' : '85vh',
          maxHeight: isMobile ? '100vh' : '90vh',
        },
      }}
    >
      <IconButton
        onClick={onClose}
        style={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
        size='small'
      >
        <CloseIcon />
      </IconButton>
      <DialogContent style={{ padding: 0, height: '100%', overflow: 'auto' }}>
        <EditRosterTemplateForm
          rosterTemplateId={rosterTemplateId}
          onSuccess={onSaved}
          onDeleted={onDeleted}
          inDialog
          fallback={
            <Box display='flex' alignItems='center' justifyContent='center' height='100%'>
              <CircularProgress />
            </Box>
          }
        />
      </DialogContent>
    </Dialog>
  );
};
